/**
 * =====================================
 * NAVIGATIONS
 * =====================================
 *
 * @package jessicariccardi_theme
 */



export default $(document).ready(function () {

  let $body = $('body');
  let $infoFullW = $('.info-modal');

  /**
   * Full screen menu
   */
  $('.info-btn').on('click', function (e) {
    e.preventDefault();
    if ($infoFullW.hasClass('is-visible')) {
      $('.info-btn').html('info');
      $infoFullW.removeClass('is-visible')
        .one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
          $body.removeClass('overflow-hidden');
        });
    } else {
      $('.info-btn').html('close');
      $infoFullW.addClass('is-visible')
        .one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
          $body.addClass('overflow-hidden');
        });
    }
  });
});
